export default "{{subject.name}}"